import React from "react";
import Caution from "assets/images/svg/caution.svg";

const CautionBox = ({ className = "", icon, text }) => (
    <div className={`${className} caution-box border-radius text-center`}>
        {icon || <Caution />}
        <p className="secondary-light-color mt-1">{text}</p>
    </div>
);

export default CautionBox;
